"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidationOverlay = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _Popper = require("../utils/_Popper");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useUniqueId = require("../utils/useUniqueId");
var _ValidationMessage = require("./_ValidationMessage");
var _ValidationOverlay = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationOverlay.css") : void 0);
var _excluded = ["children", "customLiveRegionRef", "liveRegionClassName", "show", "targetClassName", "targetProps", "validationMessage", "id"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-validation-overlay';
var ValidationOverlay = exports.ValidationOverlay = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildPropsFromContextAbove = (0, _AddChildPropsContext.useAddChildProps)();
  var liveRegionRef = (0, _react.useRef)(null);
  var props = addChildPropsFromContextAbove ? _objectSpread(_objectSpread({}, _props), addChildPropsFromContextAbove(ValidationOverlay, _props)) : _props;
  var children = props.children,
    customLiveRegionRef = props.customLiveRegionRef,
    liveRegionClassName = props.liveRegionClassName,
    show = props.show,
    targetClassName = props.targetClassName,
    targetProps = props.targetProps,
    _props$validationMess = props.validationMessage,
    validationMessage = _props$validationMess === void 0 ? {} : _props$validationMess,
    id = props.id,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref = themeProviderContext || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'concur_default' : _ref$theme;
  var classnames = _bind.default.bind(_ValidationOverlay.default);
  var validationId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    validationId = id;
  }
  var childrenArray = _react.default.Children.toArray(children);
  // Intercept Popper's context but pass parent context through to the target
  var targetComponent = /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildPropsFromContextAbove
  }, childrenArray[0]);
  if (theme.indexOf('_ios') >= 0 || theme.indexOf('_android') >= 0) {
    return targetComponent;
  }
  var overlayClasses = classnames(_constants.CSS_PREFIX, CSS_BLOCK);
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: null
  }, /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    offset: 2,
    popperClassName: overlayClasses,
    popperProps: {
      innerRef: ref,
      'aria-labelledby': validationId
    },
    show: show,
    targetClassName: targetClassName || classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__popper")),
    targetComponent: targetComponent,
    targetProps: targetProps,
    widthSizingType: "maxTarget",
    customContainer: (customLiveRegionRef === null || customLiveRegionRef === void 0 ? void 0 : customLiveRegionRef.current) || (liveRegionRef === null || liveRegionRef === void 0 ? void 0 : liveRegionRef.current)
  }, /*#__PURE__*/_react.default.createElement(_ValidationMessage.ValidationMessage, (0, _extends2.default)({}, otherProps, {
    id: validationId,
    state: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state,
    text: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text
  }))), !(customLiveRegionRef !== null && customLiveRegionRef !== void 0 && customLiveRegionRef.current) && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__live-region"), liveRegionClassName),
    "data-test": "validation-status",
    "aria-live": "polite",
    role: "status",
    ref: liveRegionRef
  }));
});
ValidationOverlay.displayName = 'ValidationOverlay';
ValidationOverlay.propTypes = {
  children: _propTypes.default.node.isRequired,
  liveRegionClassName: _propTypes.default.string,
  id: _propTypes.default.string,
  show: _propTypes.default.bool,
  targetClassName: _propTypes.default.string,
  targetProps: _propTypes.default.object,
  customLiveRegionRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  validationMessage: _propTypes.default.shape({
    state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES),
    text: _propTypes.default.string
  })
};
var _default = exports.default = ValidationOverlay;